import {getResponseStatus} from 'h3';
import {useResponseHeader, useNuxtApp} from '#app';

const MAX_AGE = 60; // 1 mn
const STALE_WHILE_REVALIDATE = 604800; // 7 days

export function usePageCache() {
    const nuxtApp = useNuxtApp();
    if (!nuxtApp.ssrContext) return;

    const setCookieHeader = useResponseHeader('Set-Cookie');
    const cacheControlHeader = useResponseHeader('Cache-Control');

    nuxtApp.hook('app:rendered', () => {
        const event = nuxtApp.ssrContext?.event;
        if (!event || getResponseStatus(event) !== 200) return;

        setCookieHeader.value = null;
        cacheControlHeader.value = `public, max-age=${MAX_AGE}, stale-while-revalidate=${STALE_WHILE_REVALIDATE}`;
    });
}
